<template>
  <div>
    <a href="#" class="view-link" @click="toggleModal">{{ translate('view') }}</a>
    <mds-modal
      v-model="visible"
      :aria-label="modalTitle"
      :class="$style['view-modal']"
      action-required
    >
      <slot name="modal-content" :close-modal="closeModal"></slot>
    </mds-modal>
  </div>
</template>

<script>
import MdsModal from '@mds/modal';

export default {
  name: 'fee-schedule-display-modal',
  components: {
    MdsModal,
  },
  props: {
    modalTitle: {
      type: String,
      default: '',
    },
  },
  inject: ['translate'],
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    closeModal() {
      this.visible = false;
    },
    toggleModal(event) {
      event.preventDefault();
      this.visible = !this.visible;
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/link';
.view-link {
  @include mds-link($underline: false);
  cursor: pointer;
  display: inline-block;
  margin-top: $mds-space-1-x;
}
.view-modal .mds-modal__content {
  overflow-y: auto;
  width: calc(800px + #{$mds-space-2-x * 2});
  padding: $mds-space-2-x;
  margin: 0 auto;
}
</style>
